import { Component } from '@angular/core';

@Component({
  template: ``,
  styles: [``],
})
export class DefaultSideNavComponent {}
